import { Component, OnInit } from '@angular/core';

import { SharedService } from "./../../../shared/shared.service";
import { AdminPrasadOrderService } from './../../services/admin-prasad-order.service';
import { PoByPaymentMode } from "./../../models/po-by-payment-mode";

@Component({
  selector: 'app-po-by-payment-mode',
  templateUrl: './po-by-payment-mode.component.html',
  styleUrls: ['./po-by-payment-mode.component.css'],
  providers: [AdminPrasadOrderService]
})
export class PoByPaymentModeComponent implements OnInit {

  constructor(
    private sharedService: SharedService,
    private adminPrasadOrderService: AdminPrasadOrderService) { }

  pOByPaymentModeList: PoByPaymentMode[] = [];
  errorMessage: string = "";

  totalSummary = {
    MOCount: 0,
    MOTotalAmount: 0,
    PayUMoneyCount: 0,
    PayUMoneyTotalAmount: 0,
    NEFTCount: 0,
    NEFTTotalAmount: 0,
    CashCount: 0,
    CashTotalAmount: 0,
    PayTMCount: 0,
    PayTMTotalAmount: 0
  }

  ngOnInit() {
    this.loadGridData();
  }

  loadGridData() {

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.GetPOByPaymentMode().subscribe(
      data => {
        console.log(data);
        this.pOByPaymentModeList = data;
        this.calculateTotals();
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  calculateTotals(){
    for (let i = 0; i < this.pOByPaymentModeList.length; i++) {
      let pOByPaymentMode = this.pOByPaymentModeList[i];

      this.totalSummary.MOCount += pOByPaymentMode.MO;
      this.totalSummary.MOTotalAmount += pOByPaymentMode.Amount * pOByPaymentMode.MO;

      this.totalSummary.PayUMoneyCount += pOByPaymentMode.PayUMoney;
      this.totalSummary.PayUMoneyTotalAmount += pOByPaymentMode.Amount * pOByPaymentMode.PayUMoney;

      this.totalSummary.NEFTCount += pOByPaymentMode.NEFT;
      this.totalSummary.NEFTTotalAmount += pOByPaymentMode.Amount * pOByPaymentMode.NEFT;

      this.totalSummary.CashCount += pOByPaymentMode.CASH;
      this.totalSummary.CashTotalAmount += pOByPaymentMode.Amount * pOByPaymentMode.CASH;

      this.totalSummary.PayTMCount += pOByPaymentMode.PayTM;
      this.totalSummary.PayTMTotalAmount += pOByPaymentMode.Amount * pOByPaymentMode.PayTM;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/po-by-payment-mode/po-by-payment-mode.component.ts